import { METHODS_ON_LEGACY_EMAIL_API } from '../../constants/returnMethods';
import sendLabelEmail from '../../lib/sendLabelEmail';
import sendConfirmationEmail from '../../lib/sendEmail';

export const UPDATE_ENABLE_EMAIL = 'UPDATE_ENABLE_EMAIL';
export const UPDATE_PRIMARY_EMAIL_ADDRESS = 'UPDATE_PRIMARY_EMAIL_ADDRESS';
export const UPDATE_SECONDARY_EMAIL_ADDRESS = 'UPDATE_SECONDARY_EMAIL_ADDRESS';
export const UPDATE_SECONDARY_EMAIL_SENT = 'UPDATE_SECONDARY_EMAIL_SENT';

export const updateEnableEmail = (enableEmail) => ({
  type: UPDATE_ENABLE_EMAIL,
  data: { enableEmail },
});

export const updateSecondaryEmailSent = (secondaryEmailSent) => ({
  type: UPDATE_SECONDARY_EMAIL_SENT,
  data: { secondaryEmailSent },
});

export const updatePrimaryEmail = (primaryEmail) => ({
  type: UPDATE_PRIMARY_EMAIL_ADDRESS,
  data: { primaryEmail },
});

export const updateSecondaryEmail = (secondaryEmail) => ({
  type: UPDATE_SECONDARY_EMAIL_ADDRESS,
  data: { secondaryEmail },
});

export const sendOrderLabelEmail = (emailAddress) => async (dispatch, getState) => {
  const {
    page: { locale, browserFingerprint } = {},
    retailerSettings: { name: retailerName } = {},
    returnSubmission: {
      returnProcessInfo: {
        return_method: selectedMethod,
        encrypted_return_id: encryptedReturnId,
      } = {},
    } = {},
  } = getState();

  const requestParams = {
    retailerName,
    encryptedReturnId,
    locale,
    email: emailAddress && emailAddress.replace(/\s|\+/g, '%2B'),
  };

  return METHODS_ON_LEGACY_EMAIL_API.includes(selectedMethod)
    ? sendLabelEmail(browserFingerprint)(requestParams)
    : sendConfirmationEmail(browserFingerprint)(requestParams);
};
